import { logException } from '../services/sentryLogger'
import { PartialParameters } from './types'
import { defaultParamsFitme } from './defaultParamsFitme'

export const p2b = (
    inValue: string,
    out: PartialParameters['assessmentParams'],
    outLabel: keyof PartialParameters['assessmentParams']
) => {
    if (!inValue) {
        return
    }
    if (inValue === '1') {
        // @ts-ignore
        out[outLabel] = true
    } else if (inValue === '0') {
        // @ts-ignore
        out[outLabel] = false
    } else {
        logException(
            'p2b converter',
            'unrecognized value: ' + inValue + ' for ' + outLabel
        )
        // @ts-ignore
        out[outLabel] = defaultParamsFitme.assessmentParams[outLabel]
    }
}

export const p2bin = (
    inValue: string,
    out: PartialParameters['assessmentParams'],
    outLabel: keyof PartialParameters['assessmentParams']
) => {
    if (!inValue) {
        return
    }
    if (inValue === '1') {
        // @ts-ignore
        out[outLabel] = 1
    } else if (inValue === '0') {
        // @ts-ignore
        out[outLabel] = 0
    } else {
        logException(
            'p2b converter',
            'unrecognized value: ' + inValue + ' for ' + outLabel
        )
        // @ts-ignore
        out[outLabel] = defaultParamsFitme.assessmentParams[outLabel]
    }
}

export const p2i = (
    inValue: string,
    out: PartialParameters['assessmentParams'],
    outLabel: keyof PartialParameters['assessmentParams']
) => {
    if (!inValue) {
        return
    }
    try {
        // @ts-ignore
        out[outLabel] = Number.parseInt(inValue, 10)
    } catch (error) {
        logException(
            'p2i converter',
            'unrecognized value: ' + inValue + ' for ' + outLabel
        )
        // @ts-ignore
        out[outLabel] = defaultParamsFitme.assessmentParams[outLabel]
    }
}

/**
 * Ex.
 * maskOutOfRange(0, 2, [2, 4, 5, 0, 20, 0, 5, 4, 2]) => [2, 4, 5, 0, 0, 0, 0, 0, 0]
 * maskOutOfRange(6, 8, [2, 4, 5, 0, 20, 0, 5, 4, 2]) => [0, 0, 0, 0, 0, 0, 5, 4, 2]
 * maskOutOfRange(4, 6, [2, 4, 5, 0, 20, 0, 5, 4, 2]) => [0, 0, 0, 6, 8, 6, 0, 0, 0]
 * 
 * @param start 
 * @param end 
 * @param array 
 */
export const maskOutOfRange = (start: number, end: number, array: number[]) => {
    return array.map((value, index) => {
        if (index >= start && index <= end) {
            return value;
        }
        return 0;
    });
}

const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
export const p2col = (
    inValue: string,
    out: PartialParameters['brandParams'],
    outLabel: keyof PartialParameters['brandParams'],
) => {
    if (!inValue) {
        return defaultParamsFitme.brandParams[outLabel]
    }
    if (HEX_COLOR_REGEX.test(inValue)) {
        // @ts-ignore
        out[outLabel] = inValue
    } else {
        const defaultColor = defaultParamsFitme.brandParams[outLabel]
        logException(
            'p2col converter',
            'unrecognized color: ' + inValue + ' for ' + outLabel +
            '; using default color: ' + defaultColor,
        )
        // @ts-ignore
        out[outLabel] = defaultColor
    }
}
